import { Api } from '@/src/store/api'
import { MesaApi } from '@acre-rewards/lib'
import { type BaseQuery } from '@/src/clients/tsrest/store/baseQuery'

const getCardActivityByCardAccountIdRoute = MesaApi['GET /card/activity-feed/:cardAccountId']
type CardActivityFeedQueryArg =
  (typeof Api)['endpoints']['GET /card/activity-feed/:cardAccountId']['Types']['QueryArg']

type CardActivityFeedResult =
  (typeof Api)['endpoints']['GET /card/activity-feed/:cardAccountId']['Types']['ResultType']

export const CardActivityApi = Api.enhanceEndpoints({
  addTagTypes: [
    'getFinalizedCardActivitiesByAccountId',
    'getFinalizedCardActivitiesByAccountIdInfinite',
  ],
}).injectEndpoints({
  endpoints: (build) => ({
    getFinalizedCardActivitiesByAccountIdInfinite: build.infiniteQuery<
      CardActivityFeedResult,
      { cardAccountId: CardActivityFeedQueryArg['params']['cardAccountId'] },
      number
    >({
      infiniteQueryOptions: {
        initialPageParam: 1,
        getNextPageParam: (lastPage, _allPages, lastPageParam, _allPageParams) => {
          const pagination = lastPage.meta.pagination
          return pagination.hasMore ? lastPageParam + 1 : undefined
        },
      },
      async queryFn(args, _api, _extraOptions, baseQuery: BaseQuery) {
        const finalized = await baseQuery({
          route: getCardActivityByCardAccountIdRoute,
          args: {
            params: {
              cardAccountId: args.queryArg.cardAccountId,
            },
            query: {
              status: 'FINALIZED',
              page: args.pageParam,
            },
          },
        })

        if (finalized.data) {
          return {
            data: finalized.data,
          }
        } else {
          return {
            error: finalized.error,
          }
        }
      },
      providesTags: ['getFinalizedCardActivitiesByAccountIdInfinite'],
    }),

    getFinalizedCardActivitiesByAccountId: build.query({
      async queryFn(args, _api, _extraOptions, baseQuery: BaseQuery) {
        const finalized = await baseQuery({
          route: getCardActivityByCardAccountIdRoute,
          args: {
            params: {
              cardAccountId: args.cardAccountId,
            },
            query: {
              status: 'FINALIZED',
            },
          },
        })

        if (finalized.data) {
          return { data: finalized.data }
        } else {
          return {
            error: finalized.error,
          }
        }
      },
      providesTags: ['getFinalizedCardActivitiesByAccountId'],
    }),
  }),
})
